export interface RenewalAccount {
    id: string;
    iban: string;
    name: string;
}

export function consentExpiry(agreement: Record<string, unknown> | undefined): number | null {
    if (!agreement) return null;
    const accepted = typeof agreement.accepted === 'string' ? Date.parse(agreement.accepted) : NaN;
    const days = Number(agreement.access_valid_for_days);
    return Number.isFinite(accepted) && Number.isInteger(days) && days > 0
        ? accepted + days * 86400000 : null;
}

const normalizeIban = (iban: string): string => iban.replace(/\s/g, '').toUpperCase();

// Never match by position/name: banks can return accounts in a different order.
export function matchRenewedAccounts(previous: RenewalAccount[], next: RenewalAccount[]): Map<string, string> {
    if (!next.length || new Set(next.map(a => a.id)).size !== next.length) {
        throw new Error('The bank has not returned a valid account list. Please try again.');
    }
    const matches = new Map<string, string>();
    for (const account of next) {
        const exact = previous.find(old => old.id === account.id);
        const candidates = exact ? [exact] : previous.filter(old =>
            normalizeIban(account.iban) && normalizeIban(old.iban) === normalizeIban(account.iban));
        if (candidates.length > 1 || (candidates[0] && [...matches.values()].includes(candidates[0].id))) {
            throw new Error('The bank returned ambiguous account identities. Your existing connection has been kept.');
        }
        if (candidates[0]) matches.set(account.id, candidates[0].id);
        else if (!normalizeIban(account.iban) || previous.some(old => !normalizeIban(old.iban))) {
            throw new Error('Could not safely match the renewed accounts. Your existing connection has been kept. Please contact support.');
        }
    }
    return matches;
}
